module.exports = __webpack_public_path__ + "img/img28.53a36543.jpg";